var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"emergency-overlay"},[_c('v-row',{staticClass:"white--text mt-12 pt-12"},[_c('v-col',{staticClass:"col-12 text-center headline-large"},[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }